export * from './IconBookmarkFilled';
